import { pathOr } from "ramda";
import { createSelector } from "reselect";

import { getVerticalConfig } from "./index.js";

export const getVerticalFilteringConfiguration = createSelector(
	[getVerticalConfig],
	(verticalConfig) => pathOr({}, ["filteringInformation"], verticalConfig),
);
